import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';
import CommonTitle from '../../../common-components/common-title';

const webpractikTeam = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Александр Букуров',
            crewItemSubtitle: 'руководитель проекта',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Полина Герасимова',
            crewItemSubtitle: 'менеджер проектов отдела разработки',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Иван Поддубный',
            crewItemSubtitle: 'руководитель отдела разработки',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Сергей Волошин',
            crewItemSubtitle: 'Back-end teamlead',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Анна Золотова',
            crewItemSubtitle: 'Front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Павел Воробьёв',
            crewItemSubtitle: 'старший Front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Константин Кулишов',
            crewItemSubtitle: 'старший DevOps инженер',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Сергей Буланов',
            crewItemSubtitle: 'Back-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Пётр Клёнкин',
            crewItemSubtitle: 'старший Back-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Александр Гурнак',
            crewItemSubtitle: 'Back-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Сергей Аверкиев',
            crewItemSubtitle: 'Back-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Пётр Шкумат',
            crewItemSubtitle: 'Back-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Мария Лапиева',
            crewItemSubtitle: 'старший Front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Антон Шевцов',
            crewItemSubtitle: 'Front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Сергей Близнюк',
            crewItemSubtitle: 'Front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Даниил Никонюк',
            crewItemSubtitle: 'Front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Дмитрий Волошин',
            crewItemSubtitle: 'Front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Олеся Прокопенко',
            crewItemSubtitle: 'Front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Мурад Саркаров',
            crewItemSubtitle: 'Front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Василий Яковенко',
            crewItemSubtitle: 'Front-end разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Николай Цай',
            crewItemSubtitle: 'старший дизайнер',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Анна Сластён',
            crewItemSubtitle: 'дизайнер',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Роман Возный',
            crewItemSubtitle: 'контент-менеджер',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <FullWrapper caseName="team" isMargin={false}>
                <CommonTitle>Команда</CommonTitle>
                <CrewContainer container={webpractikTeam} />
            </FullWrapper>
        );
    }
}

export default Team;
